// Nội dung trang trượt vào theo hướng công tắc khi người dùng BẤM đổi Quản lý ⇄ Bán hàng.
// Gắn class trước khi trình duyệt vẽ (useLayoutEffect) nên không nháy nội dung mới ở vị trí cũ;
// bỏ class khi chạy xong để phần tử không giữ transform (fixed/sticky bên trong vẫn đúng chỗ).
// Máy bật "Giảm chuyển động" → index.css rút thời gian về ~0, coi như đổi ngay.

import { useLayoutEffect, useRef } from 'react'
import { takeModeSwitchDir, type WorkMode } from '@/lib/workMode'

const CLS = { left: 'mode-slide-left', right: 'mode-slide-right' } as const

export function useModeSlide<T extends HTMLElement>(mode: WorkMode) {
  const ref = useRef<T>(null)
  const first = useRef(true)
  useLayoutEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    const dir = takeModeSwitchDir()
    const el = ref.current
    if (!dir || !el) return
    el.classList.remove(CLS.left, CLS.right)
    void el.offsetWidth // chạy lại animation nếu bấm liên tục
    el.classList.add(CLS[dir])
    const done = () => el.classList.remove(CLS[dir])
    el.addEventListener('animationend', done, { once: true })
    return () => el.removeEventListener('animationend', done)
  }, [mode])
  return ref
}
